export default __webpack_public_path__ + "static/media/company_alt.80fdec30.png";